<template>
  <div class="theme-toggle-container">
    <button class="theme-toggle" @click="toggleTheme">
      <!-- Sun icon (visible in dark mode) -->
      <svg
        v-if="isDark"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2" />
        <path d="M12 20v2" />
        <path d="m4.93 4.93 1.41 1.41" />
        <path d="m17.66 17.66 1.41 1.41" />
        <path d="M2 12h2" />
        <path d="M20 12h2" />
        <path d="m6.34 17.66-1.41 1.41" />
        <path d="m19.07 4.93-1.41 1.41" />
      </svg>
      <!-- Moon icon (visible in light mode) -->
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    showAdvanced: {
      type: Boolean,
      default: false, // по умолчанию простой переключатель
    },
  },

  data() {
    return {
      currentPreference: "system",
      isDark: false,
    };
  },

  methods: {
    updateThemeState() {
      if (this.$colorMode) {
        this.currentPreference = this.$colorMode.preference;
        this.isDark = this.$colorMode.value === "dark";
      } else {
        // Fallback на определение из DOM
        this.isDark = document.documentElement.classList.contains("dark");
      }
    },

    toggleTheme() {
      if (this.$colorMode) {
        this.$colorMode.preference = this.isDark ? "light" : "dark";
      } else {
        // Ручное переключение, если модуль не работает
        const isDark = document.documentElement.classList.contains("dark");
        document.documentElement.classList.toggle("dark", !isDark);
        localStorage.setItem("theme-preference", !isDark ? "dark" : "light");
        this.isDark = !isDark;
      }
    },
  },

  mounted() {
    // Восстанавливаем тему из localStorage
    const saved = localStorage.getItem("theme-preference");
    if (saved) {
      document.documentElement.classList.toggle("dark", saved === "dark");
    }

    this.updateThemeState();

    // Следим за изменениями в DOM
    const observer = new MutationObserver(() => {
      this.updateThemeState();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });

    // Слушаем изменения системной темы
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", () => {
        if (this.currentPreference === "system") {
          this.updateThemeState();
        }
      });
  },
};
</script>

<style scoped>
.theme-toggle {
  @apply inline-flex h-8 w-8 items-center justify-center rounded-md border border-border bg-background transition-colors outline-none text-gray-500;
  &:hover {
    @apply text-gray-900;
    background-color: rgb(var(--color-gray-100));
  }
}
</style>
